import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import { FiLogOut } from "react-icons/fi";

import styles from "../styles/Navbar.module.css";
import nav_logo from "../assets/images/nav_logo.png";

const VideoWatchNavbar = () => {

  return (
    <>
      <div className={styles.navbar_spacer}></div>
      <div className={styles.navbar}>
        <img className={styles.nav_logo} src={nav_logo} alt="" />
      
      </div>
      <div className={styles.navbar_separator}></div>
    </>
  );
};

export default VideoWatchNavbar;
